/**
 * Centralized TanStack Query keys
 */
export const queryKeys = {
  spaces: {
    all: ["spaces"] as const,
  },
  castings: {
    all: ["castings"] as const,
  },
  rooms: {
    public: (tenantSlug: string) => ["rooms", "public", tenantSlug] as const,
    mine: (tenantSlug: string) => ["rooms", "mine", tenantSlug] as const,
  },
  calendar: {
    public: (tenantSlug: string, roomId: string, monthKey: string) =>
      ["calendar", "public", tenantSlug, roomId, monthKey] as const,
    mine: (tenantSlug: string, roomId: string, monthKey: string) =>
      ["calendar", "mine", tenantSlug, roomId, monthKey] as const,
    mineAll: (tenantSlug: string) => ["calendar", "mine", tenantSlug] as const,
    publicAll: (tenantSlug: string) =>
      ["calendar", "public", tenantSlug] as const,
  },
} as const;
